export const SubAdminMenuList = [
  //Dashboard
  // {
  //   title: "Dashboard",
  //   classsChange: "mm-collapse",
  //   iconStyle: <i className="fas fa-home"></i>,
  // },

  {
    title: "Registration",
    classsChange: "mm-collapse",
    iconStyle: <i className="fas fa-id-card" />,
    to: "registration",
    url: "registration",
  },
  {
    title: "Manage Registration",
    classsChange: "mm-collapse",
    // update:"New",
    iconStyle: <i className="fas fa-users" />,
    content: [
      {
        title: "Institution List",
        to: "Organization",
      },
      {
        title: "Individual  List",
        to: "Individual",
      },
    ],
  },
  {
    title: "Communication Hub",
    classsChange: "mm-collapse",
    // update:"New",
    iconStyle: <i className="fas fa-comments" />,
    content: [
      {
        title: "Forum & Chat",
        to: process.env.REACT_APP_COMMUNICATION_HUB,
      },
    ],
  },

  {
    title: "Manage Verification",
    classsChange: "mm-collapse",
    // update:"New",
    iconStyle: <i className="fas fa-suitcase" />,
    content: [
      {
        title: "Institution  Verification List",
        to: "verified-institute-user",
      },
      {
        title: "Individual Verification List",
        to: "verified-individual-user",
      },
    ],
  },
  {
    title: "Attendance Management",
    classsChange: "mm-collapse",
    iconStyle: <i className="fas fa-calendar-check" />,
    content: [
      {
        title: "Attendance",
        to: process.env.REACT_APP_ATTENDANCE_URL,
      },
    ],
  },

  /* {
    title: "Edit Profile",
    classsChange: "mm-collapse",
    iconStyle: <i class="bi bi-pencil-square"></i>,
    content: [
      {
        title: "Request List",
        to: "edit-profile-requests",
      },
    ],
  }, */
  {
    title: "Grant Schemes",
    classsChange: "mm-collapse",
    iconStyle: <i className="fas fa-calendar-check" />,
    content: [
      {
        title: "Schemes Management",
        to: process.env.REACT_APP_SCHEME_FORMBUILDER_MANAGEMENT_URL,
      },
    ],
  },


];

export const AdminMenuList = [
   {
    title: "Dashboard",
    classsChange: "mm-collapse",
    // update:"New",
    iconStyle: <i className="fas fa-users" />,
    content: [
      {
        title: "Dashboard",
        to: "dashboard",
      },
     
    ],
  },

  {
    title: "Registration",
    classsChange: "mm-collapse",
    iconStyle: <i className="fas fa-id-card" />,
    to: "registration",
    url: "registration",
  },
  {
    title: "Manage Registration",
    classsChange: "mm-collapse",
    // update:"New",
    iconStyle: <i className="fas fa-users" />,
    content: [
      {
        title: "Institution List",
        to: "Organization",
      },
      {
        title: "Individual  List",
        to: "Individual",
      },
    ],
  },

  {
    title: "Communication Hub",
    classsChange: "mm-collapse",
    // update:"New",
    iconStyle: <i className="fas fa-comments" />,
    content: [
      {
        title: "Forum & Chat",
        to: process.env.REACT_APP_COMMUNICATION_HUB,
      },
    ],
  },

  {
    title: "Manage Verification",
    classsChange: "mm-collapse",
    // update:"New",
    iconStyle: <i className="fas fa-suitcase" />,
    content: [
      {
        title: "Institution  Verification List",
        to: "verified-institute-user",
      },
      {
        title: "Individual Verification List",
        to: "verified-individual-user",
      },
    ],
  },

  {
    title: "Notification Management",
    to: "communication",
    iconStyle: <i class="bi bi-bell-fill"></i>,
    content: [
      {
        title: "Communication",
        to: "communication/communication-list",
      },
      {
        title: "Website Notification",
        to: "communication/website-notification-list",
      },
    ],
  },
  {
    title: "Event Management",
    to: "event/event-calendar",
    iconStyle: <i class="bi bi-calendar-event-fill"></i>,
    content: [
      {
        title: "Event",
        to: "event/event-calendar",
      },
    ],
  },
  {
    title: "Grievance Management",
    to: "communication",
    iconStyle: <i class="bi bi-chat-fill"></i>,
    content: [
      {
        title: "Grievance Management",
        to: "grievance-management",
      },
      {
        title: "Public Grievance",
        to: "public-grievance",
      },
    ],
  },
  {
    title: "Manage DSO",
    classsChange: "mm-collapse",
    // update:"New",
    iconStyle: <i className="fas fa-users" />,
    content: [
      {
        title: "Create DSO",
        to: "manage-dso",
      },
      // {
      //   title: "Individual  List",
      //   to: "Individual",
      // },
    ],
  },
  {
    title: "Venue Infra",
    classsChange: "mm-collapse",
    // update:"New",
    iconStyle: <i className="fas fa-building" />,
    content: [
      {
        title: "Venue List",
        to: process.env.REACT_APP_VENUE_INFRA_URL,
      },
      // {
      //   title: "Individual  List",
      //   to: "Individual",
      // },
    ],
  },
   {
    title: "DIGI ACCRED Management",
    classsChange: "mm-collapse",
    // update:"New",
    iconStyle: <i className="fas fa-building" />,
    content: [
      {
        title: "Digital Certificated and Accred",
        to: process.env.REACT_APP_DIGI_ACCRED_MANAGEMENT_URL,
      },
      // {
      //   title: "Individual  List",
      //   to: "Individual",
      // },
    ],
  },
  {
    title: "Attendance Management",
    classsChange: "mm-collapse",
    iconStyle: <i className="fas fa-calendar-check" />,
    content: [
      {
        title: "Attendance",
        to: process.env.REACT_APP_ATTENDANCE_URL,
      },
    ],
  },

  {
    title: "Grant Schemes",
    classsChange: "mm-collapse",
    iconStyle: <i className="fas fa-calendar-check" />,
    content: [
      {
        title: "Schemes Management",
        to: process.env.REACT_APP_SCHEME_FORMBUILDER_MANAGEMENT_URL,
      },
    ],
  },

  /* {
    title: "Edit Profile",
    classsChange: "mm-collapse",
    iconStyle: <i class="bi bi-pencil-square"></i>,
    content: [
      {
        title: "Request List",
        to: "edit-profile-requests",
      },
    ],
  }, */
  // {
  //   title: "Scheme Management",
  //   classsChange: "mm-collapse",

  //   iconStyle: <i className="fas fa-map-marker" />,
  //   content: [
  //     {
  //       title: "Applications List",
  //       to: process.env.REACT_APP_SCHEME_MANAGEMENT_URL,
  //     },

  //   ],
  // },
  // {
  //   title: "Edit Profile Request",
  //   classsChange: "mm-collapse",
  //   iconStyle: <i class="bi bi-pencil-square"></i>,
  //   content: [
  //     {
  //       title: "Edit Profile Request List",
  //       to: "edit-profile-requests",
  //     },
  //   ],
  // },
];

export const UserMenuList = () => {
  const user_category_main = localStorage.getItem("user_category_main");
    const token = localStorage.getItem("access_token_admin");

  const category_type = localStorage.getItem("category_type");
  // const userDataSubCategory = JSON.parse(localStorage.getItem("userData"));
let userDataSubCategory = {};

try {
  const data = localStorage.getItem("userData");
  userDataSubCategory = data ? JSON.parse(data) : {};
} catch (error) {
  console.error("Invalid userData in localStorage:", error);
  userDataSubCategory = {};
}

 


  return [
    {
      title: "Registration",
      classsChange: "mm-collapse",
      iconStyle: <i className="fas fa-id-card"></i>,
      to: "registration",
      url: "registration",
    },
    {
      title: "Grievance Management",
      classsChange: "mm-collapse",
      iconStyle: <i className="bi bi-ticket-perforated-fill"></i>,
      content: [
        {
          title: "Tickets",
          to: "user-grievance-management",
        },
      ],
    },
    {
          title: "Academy Management",
          classsChange: "mm-collapse",
          iconStyle: <i className="bi bi-calendar-event-fill"></i>,
          content: [
            {
              title: "Dashboard",
              to: "batch-management/dashboard",
            },
            {
              title: "Batches",
              to: "batch-management/batches",
            },
            {
              title: "Calendar",
              to: "batch-management/calendar",
            },
            {
              title: "Attendance",
              to: "batch-management/attendance-report",
            },
          ],
        },
    {
      title: "Notifications",
      to: "notification",
    },
    {
      title: "Account Management",
      classsChange: "mm-collapse",
      iconStyle: <i className="bi bi-ticket-perforated-fill"></i>,
      content: [
        {
          title: "Delete Account",
          to: "user/delete-account",
        },
      ],
    },
    {
    title: "Grant Schemes",
    classsChange: "mm-collapse",
    iconStyle: <i className="fas fa-calendar-check" />,
    content: [
      {
        title: "Schemes Management",
        to: process.env.REACT_APP_SCHEME_FORMBUILDER_MANAGEMENT_URL,
      },
    ],
  },

  
    ...((category_type == 1 || category_type == 10 || category_type == 2) && user_category_main == 1
      ? [
        {
          title: "Apply For Discount",
          classsChange: "mm-collapse",
          iconStyle: <i className="bi bi-ticket-perforated-fill"></i>,
          to: "apply-for-discount",
        },
        {
          title: "Assessment Report",
          classsChange: "mm-collapse",
          iconStyle: <i className="bi bi-ticket-perforated-fill"></i>,
          content: [

            {
              title: "Report",
              to: "assessment-reports",
            },


          ],
        },
      ]
      : []),

    ...(userDataSubCategory?.sub_category_type == 2 && user_category_main == 1
      ? [

        {
          title: "Assessment Management",
          classsChange: "mm-collapse",
          iconStyle: <i className="bi bi-ticket-perforated-fill"></i>,
          content: [

            {
              title: "Assessment Overview",
              to: process.env.REACT_APP_ASSESMENT_MANAGEMENT_COACH_URL || 'https://staging-assesment.jharkhandsports.in/user/overview',
            },


          ],
        },
      ]
      : [
      ]),

      

    ...(user_category_main != 2
      ? [
        {
          title: "Book and Play",
          classsChange: "mm-collapse",
          iconStyle: <i className="bi bi-ticket-perforated-fill"></i>,
          external: true,
          to: `${process.env.REACT_APP_WEBSITE_URL}/venue-list`,
        },
      ]
      : [
        {
          title: "Assessment Management",
          classsChange: "mm-collapse",
          // update:"New",
          iconStyle: <i className="fas fa-map-marker" />,
          content: [
            {
              title: "Assessment Overview",
              to: process.env.REACT_APP_ASSESMENT_MANAGEMENT_URL || 'https://staging-assesment.jharkhandsports.in/admin/overview',
            },
          ],
        },
      ]),

     ...(user_category_main == 2
  ? [
      {
        title: "TMS Management",
        classsChange: "mm-collapse",
        iconStyle: <i className="fas fa-building" />,
        content: [
          {
            title: "TMS",
            to: `${process.env.REACT_APP_TMS_URL}/auth/autologin?access_token=${token}`,
          },
        ],
      },
    ]
  : []),
    /* {
      title: "Edit Profile",
      classsChange: "mm-collapse",
      iconStyle: <i className="bi bi-ticket-perforated-fill"></i>,
      content: [

        {
          title: "Request",
          to: "edit-profile",
        },
        {
          title: "History",
          to: "edit-profile-history",
        },

      ],
    }, */



  ];
};

export const VenueManagerList = [
  //Dashboard
  // {
  //   title: "Dashboard",
  //   classsChange: "mm-collapse",
  //   iconStyle: <i className="fas fa-home"></i>,
  // },

  {
    title: "Dashboard",
    classsChange: "mm-collapse",
    // update:"New",
    iconStyle: <i className="fas fa-users" />,
    content: [
      {
        title: "Venue Manager",
        to: "venue-manager",
      },
    ],
  },
  {
    title: "Booking",
    classsChange: "mm-collapse",
    // update:"New",
    iconStyle: <i className="fas fa-suitcase" />,
    content: [
      {
        title: "Booking List",
        to: "booking-list",
      },
    ],
  },
];
